import { useEffect, useState } from "react";
import type { PlayerTrendsResponse } from "@chessla/shared";
import type { PerformanceQuery } from "@/features/performance-selection";
import { fetchPlayerTrends } from "./trends.api";
import { useUserSettingsStore } from "@/features/preferences/user-settings.store";

export const useTrends = ({ format, exactTimeControl }: PerformanceQuery) => {
  const period = useUserSettingsStore((state) => state.settings.trendsDefaultPeriod);
  const owner = useUserSettingsStore((state) => state.ownerUserId);
  const [data, setData] = useState<PlayerTrendsResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    setData(null);
    setLoading(true);
    setError(null);
    void fetchPlayerTrends({ format, exactTimeControl, period }, controller.signal)
      .then((result) => {
        if (!controller.signal.aborted) setData(result);
      })
      .catch((reason: unknown) => {
        if (!controller.signal.aborted)
          setError(reason instanceof Error ? reason.message : "Trends could not be loaded");
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [exactTimeControl, format, period, owner]);

  return { data, error, loading };
};
